import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Button, Divider, Paper, Typography } from '@mui/material'
import ROUTES from '../../../routesConfig'
import MarketingPageLayout from './MarketingPageLayout'

const WeddingsPage = () => {
  return (
    <MarketingPageLayout>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3.5 }}>
        <Box>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 800, mb: 1 }}>
            Anear for Weddings
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.65, color: 'rgba(230,233,239,0.9)' }}>
            Weddings bring people together—but many guests don’t know each other yet. Anear turns that into an opportunity.
          </Typography>
          <Typography variant="body1" sx={{ mt: 1.25, lineHeight: 1.65, color: 'rgba(230,233,239,0.9)' }}>
            With simple, phone-based games and activities, Anear helps guests connect, laugh, and participate—without interrupting
            the celebration.
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            bgcolor: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 2,
            p: 2.5,
          }}
        >
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1.5 }}>
            Perfect for Wedding Moments
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Guest trivia — questions about the couple
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Photo prompts &amp; polls — fun, lightweight interaction
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Live Q&amp;A — speeches, toasts, or stories
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Icebreakers — help guests mingle naturally
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ mt: 1.25, color: 'rgba(230,233,239,0.9)', lineHeight: 1.65 }}>
            Guests scan a QR code from a table card or display and join instantly. No apps. No logins. No awkward setup.
          </Typography>
        </Paper>

        <Box>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
            For Planners, Photographers &amp; Couples
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Planners can add interactive moments to their packages
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Photographers can create engagement before and between shots
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Couples can run activities themselves with zero tech overhead
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ mt: 1.25, color: 'rgba(230,233,239,0.9)', lineHeight: 1.65 }}>
            Everything runs in the browser and works on any modern phone.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
            Designed for the Room, Not the Internet
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)', lineHeight: 1.65 }}>
            Anear experiences are built for people in the same space, sharing the same moment. It’s not about screen time — it’s
            about together time.
          </Typography>
        </Box>

        <Box>
          <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', mb: 1.5 }} />
          <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap' }}>
            <Button component={RouterLink} to={ROUTES.APPS} variant="contained" color="primary" sx={{ fontWeight: 700 }}>
              Explore apps
            </Button>
            <Button
              component={RouterLink}
              to={ROUTES.HOW_IT_WORKS}
              variant="outlined"
              sx={{ fontWeight: 700, color: '#E6E9EF', borderColor: 'rgba(255,255,255,0.25)' }}
            >
              How it works
            </Button>
          </Box>
        </Box>
      </Box>
    </MarketingPageLayout>
  )
}

export default WeddingsPage


